import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('doctor-details');

export const ADD_DOCTOR = getActionName('ADD_DOCTOR');
export const UPDATE_DOCTOR = getActionName('UPDATE_DOCTOR');
export const DELETE_DOCTOR = getActionName('DELETE_DOCTOR');
